/* tslint:disable */
/* eslint-disable */

/**
 * 401130004 = Organisation (Organisation)
 * 
 * 401130012 = AntragstellerKontakt (Antragsteller Kontakt)
 * 
 * 401130001 = Projektdetails (Projektdetails)
 * 
 * 401130009 = Fragen (Fragen)
 * 
 * 401130006 = Finanzierung (Finanzierung)
 * 
 * 401130010 = FinanzierungmitFPImport (Finanzierung mit FP Import)
 * 
 * 401130011 = Meilensteine (Meilensteine)
 * 
 * 401130007 = Anlagen (Anlagen)
 * 
 * 401130013 = Mittelabruf (Mittelabruf)
 * 
 * 401130014 = DetailsStipendium (Details Stipendium)
 * 
 * 401130015 = GutachtenminusBegutachtung (Begutachtung)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceFormulartyp {
 Organisation = 401130004,
 AntragstellerKontakt = 401130012,
 Projektdetails = 401130001,
 Fragen = 401130009,
 Finanzierung = 401130006,
 FinanzierungmitFPImport = 401130010,
 Meilensteine = 401130011,
 Anlagen = 401130007,
 Mittelabruf = 401130013,
 DetailsStipendium = 401130014,
 GutachtenminusBegutachtung = 401130015
}

marker([
    "Enum.GlobalEnumsAceFormulartyp.Organisation",
    "Enum.GlobalEnumsAceFormulartyp.AntragstellerKontakt",
    "Enum.GlobalEnumsAceFormulartyp.Projektdetails",
    "Enum.GlobalEnumsAceFormulartyp.Fragen",
    "Enum.GlobalEnumsAceFormulartyp.Finanzierung",
    "Enum.GlobalEnumsAceFormulartyp.FinanzierungmitFPImport",
    "Enum.GlobalEnumsAceFormulartyp.Meilensteine",
    "Enum.GlobalEnumsAceFormulartyp.Anlagen",
    "Enum.GlobalEnumsAceFormulartyp.Mittelabruf",
    "Enum.GlobalEnumsAceFormulartyp.DetailsStipendium",
    "Enum.GlobalEnumsAceFormulartyp.GutachtenminusBegutachtung"
]);

export namespace GlobalEnumsAceFormulartyp
{
    class DataSets
    {
        static GlobalEnumsAceFormulartypDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Organisation", 401130004, "Organisation"),
            new EnumValue("AntragstellerKontakt", 401130012, "Antragsteller Kontakt"),
            new EnumValue("Projektdetails", 401130001, "Projektdetails"),
            new EnumValue("Fragen", 401130009, "Fragen"),
            new EnumValue("Finanzierung", 401130006, "Finanzierung"),
            new EnumValue("FinanzierungmitFPImport", 401130010, "Finanzierung mit FP Import"),
            new EnumValue("Meilensteine", 401130011, "Meilensteine"),
            new EnumValue("Anlagen", 401130007, "Anlagen"),
            new EnumValue("Mittelabruf", 401130013, "Mittelabruf"),
            new EnumValue("DetailsStipendium", 401130014, "Details Stipendium"),
            new EnumValue("GutachtenminusBegutachtung", 401130015, "Begutachtung"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceFormulartypDataSet;
    }
}
